/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getVariants } from './getVariants';

export const getMasterProduct = createAsyncThunk(
  'products/getMasterProduct',
  async ({ productId }, {
    dispatch, getState, extra: { Logger, sdk },
  }) => {
    try {
      const { data } = await sdk.products.getMasterProduct(productId);
      const currentProduct = getState().products.items.find(({ _id }) => _id === productId);
      if (!currentProduct?.variants?.length) {
        await dispatch(getVariants({ _id: productId }));
      }
      return data;
    } catch (error) {
      Logger.log('UI', 'ToastProductGetFailed');
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    getMasterProduct.pending,
    (state, { meta }) => {
      const { productId } = meta.arg;
      const item = state.items.find(({ _id }) => _id === productId);
      if (item) item.isLoading = true;
      state.error = null;
    },
  ).addCase(
    getMasterProduct.fulfilled,
    (state, { payload: product }) => {
      const item = state.items.find(({ _id }) => _id === product._id);
      if (!item) return;
      Object.assign(item, product, {
        isLoading: false,
        variants: item.variants?.length ? item.variants : (product.variants || []),
      });
    },
  ).addCase(
    getMasterProduct.rejected,
    (state, { error, meta }) => {
      const { productId } = meta.arg;
      const item = state.items.find(({ _id }) => _id === productId);
      if (item) item.isLoading = false;
      state.error = error;
    },
  );
};
